import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Divider, IconButton, MenuItem, Typography } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

import BusinessStats2 from '../BusinessStats2'
import { updateSelectedBusiness } from 'store/actions/businessListingActions'
import { useNavigate } from 'react-router-dom'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuList from '@mui/material/MenuList'
import { BusinessAvatarSearch } from 'components/MyBusiness/BusinessAvatarSearch'

const sx = {
  root: {
    borderRadius: "10px",
    backgroundColor: '#fff',
    boxShadow: '0 4px 13px 0 rgba(0,91,136,0.18)',
    overflow: 'hidden',
    height: '100%',
    width: 300,
    position: 'relative',
  },
  imageWrapper: {
    marginTop: theme => theme.spacing(3),
    marginBottom: theme => theme.spacing(2),
  }
}

const BusinessCardSquare = ({ model, onRemoveClick, isMonitored }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [menuAnchorEl, setMenuAnchorEl] = useState(null)

  const openBusinessInfo = () => {
    navigate('/details')
    updateSelectedBusiness(dispatch, model)
  }

  const onMoreClick = useCallback(event => {
    setMenuAnchorEl(event.currentTarget)
  }, [])

  const onMenuClose = useCallback(() => {
    setMenuAnchorEl(null)
  }, [])

  const onRemoveClickInternal = useCallback(() => {
    setMenuAnchorEl(null)
    if (onRemoveClick) {
      onRemoveClick(model)
    }
  }, [model, onRemoveClick])

  return (
    <Box sx={sx.root}>
      {isMonitored && (
        <Box position="absolute" top={0} right={0} mr={1}>
          <IconButton onClick={onMoreClick}>
            <MoreHorizIcon />
          </IconButton>
          <Popper open={!!menuAnchorEl} anchorEl={menuAnchorEl} role={undefined} placement="bottom-start" transition>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={onMenuClose}>
                    <MenuList autoFocusItem={!!menuAnchorEl}>
                      <MenuItem style={{ fontSize: '14px', fontFamily: 'poppins' }} onClick={onRemoveClickInternal}>
                        Remove From List
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      )}
      <div onClick={openBusinessInfo} style={{ cursor: 'pointer' }}>
        <Box display="flex" justifyContent="center">
          <Box sx={sx.imageWrapper}>
            <BusinessAvatarSearch model={model} width={92} height={92} />
          </Box>
        </Box>
        <Box mx={2} my={2} color="#CEE4F5">
          <Divider orientation="horizontal" />
        </Box>
        <Box color="#0076C5" marginLeft="25px">
          <Typography variant="h6">{model.details.businessName || model.company}</Typography>
        </Box>
        <Box ml={3}>
          <BusinessStats2 model={model} small />
        </Box>
      </div>
    </Box>
  )
}

export default BusinessCardSquare
